import {Cookie} from '../helpers/cookie';
import {ElementHelpers} from '../helpers/element-helpers';

export class Notification {
	constructor(elem) {
		this.elem = elem;
		this.cookieName = this.elem.dataset.notification;
		this.duration = 30;
		this.close = this.elem.querySelector('[data-close-notification]');

		this.addEventListeners();
	}

	addEventListeners(){
		this.close.addEventListener('click', (e) => {
			e.preventDefault();
			this.handleClose();
		})
	}

	handleClose(){
		Cookie.setCookie(this.cookieName, true, this.duration);
		ElementHelpers.removeElement(this.elem);
	}

	static getSelector() {
		return '[data-notification]';
	}
}
